import React from 'react'
import {Card, ListGroup} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import './style.css'

export default function cardspopup() {
    return (
        <Card className="toko-nav">
        <Card.Body>
            <img src="asset/dashboard/icons/toko.svg" alt="toko" />
            Muhammad Rifqi Mubarak
        </Card.Body>
            <ListGroup variant="flush">
                {
                    Items.map((data, i) => {
                        return (
                            <ListGroup.Item><Link key={i} to={data.link}>{data.name}</Link></ListGroup.Item>
                        )
                    })
                }
            </ListGroup>   
        </Card>
    )
}

const Items = [
    {name:"Toko Saya", link:"/toko_reseller"},
    {name:"Barang Terjual", link:"/barang_terjual"},
    {name:"Produk yang Dijual", link:"/produk_dijual"}
]
